// src/App.jsx
import KeyFigureArticle from "./pages/KeyFigureArticle";
import { Analytics } from "@vercel/analytics/react";
import Library from "./pages/Library";
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import ResearchArticle from "./pages/ResearchArticle";
import LibraryResource from "./pages/LibraryResource";
import RouteSeo from "./components/Seo";
import "./components/ThesaurusFlat.css";
import Navigation from './components/Navigation';
import Home from './components/Home';
import About from './components/About';
import Books from './components/Books';
import PhilosophyLayer from './components/PhilosophyLayer';
import MinervaShrine from './pages/MinervaShrine';
import RomanTimelineScroll from './components/RomanTimelineScroll';
import Characters from './components/Characters';
import Links from './components/Links';
import Investigations from './pages/Investigations';
import RomanTerms from './pages/RomanTerms';
import RomanRoadsExplorer from "./pages/RomanRoadsExplorer";

import {
  Research,
  Media,
  Maps,
  CharactersByTribe,
  CharactersByRole,
  CharactersByAllegiance,
  CharactersTimeline,
} from './components/PlaceholderPages';

import Legio2Timeline from "./pages/Legio2Timeline";
import AllLegionsTimeline from "./pages/AllLegionsTimeline";
import RomanMilitaryArchive from "./pages/RomanMilitaryArchive";
import MilitaryDossier from "./pages/MilitaryDossier";

// Conquest page (React route so navbar remains)
import ConquestOfBritannia from "./pages/ConquestOfBritannia";

import './App.css';

// Visual Thesaurus
import ThesaurusPage from './pages/Thesaurus.jsx';

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-stone-900">
        <RouteSeo />
        <Navigation />
        <Routes>
          {/* Core */}
	<Route path="/investigations" element={<Investigations />} />
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/books" element={<Books />} />
          <Route path="/philosophy" element={<PhilosophyLayer />} />
          <Route path="/quiet-shift" element={<Navigate to="/philosophy" replace />} />
          <Route path="/philosophy/minerva-shrine" element={<MinervaShrine />} />

          <Route path="/characters" element={<Characters />} />
          <Route path="/characters/tribes" element={<CharactersByTribe />} />
          <Route path="/characters/roles" element={<CharactersByRole />} />
          <Route path="/characters/allegiance" element={<CharactersByAllegiance />} />
          <Route path="/characters/timeline" element={<CharactersTimeline />} />

          <Route path="/links" element={<Links />} />
          <Route path="/library" element={<Library />} />
          <Route path="/library/:slug" element={<LibraryResource />} />
          <Route path="/timeline" element={<RomanTimelineScroll />} />
	<Route path="/key-figures/:slug" element={<KeyFigureArticle />} />
          <Route path="/thesaurus" element={<ThesaurusPage />} />
          <Route path="/media" element={<Media />} />

          {/* Hubs */}
          <Route path="/maps" element={<Maps />} />
          <Route path="/research" element={<Research />} />
          <Route path="/research/roman-terms" element={<RomanTerms />} />
          <Route path="/research/roman-britain-timeline/:slug" element={<ResearchArticle />} />
<Route path="/maps" element={<Maps />} />
<Route path="/maps/roman-roads-explorer" element={<RomanRoadsExplorer />} />
          {/* Re-homed pages */}
          <Route path="/maps/legions" element={<AllLegionsTimeline />} />
          <Route path="/military" element={<RomanMilitaryArchive />} />
          <Route path="/military/:id" element={<MilitaryDossier />} />
          <Route path="/research/conquest" element={<ConquestOfBritannia />} />

          {/* Existing pages */}
          <Route path="/legio2-timeline" element={<Legio2Timeline />} />

          {/* Old URLs redirects */}
          <Route path="/legions-timeline" element={<Navigate to="/maps/legions" replace />} />
          <Route path="/conquest-britannia" element={<Navigate to="/research/conquest" replace />} />

          {/* Friendly short links */}
          <Route path="/legions" element={<Navigate to="/maps/legions" replace />} />
          <Route path="/military-archive" element={<Navigate to="/military" replace />} />
          <Route path="/conquest" element={<Navigate to="/research/conquest" replace />} />

          {/* Existing redirects */}
          <Route path="/tribes-places" element={<Navigate to="/research" replace />} />
          <Route path="/contact" element={<Navigate to="/research" replace />} />

          {/* Fallback */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>

        <Analytics />
      </div>
    </Router>
  );
}

export default App;
